export const TIPOS_PAGO = {
  CONTADO: "contado",
  MESES_SIN_INTERESES: "mesesSinIntereses",
};
